/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component, Fragment } from "react";
import ButtonGroup from "@react/react-spectrum/ButtonGroup";
import ZoomUICss from "./ZoomUI.css";
import { ZoomInContainer } from "containers/hud/ZoomInContainer";
import { ZoomOutContainer } from "containers/hud/ZoomOutContainer";
import { LMViewSwitcherContainer } from "containers/hud/LMViewSwitcherContainer";

class ZoomUI extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.enableZoomFeature !== this.props.enableZoomFeature) {
      if (this.props.enableZoomFeature) {
        this.props.init();
      } else {
        this.props.cleanup();
      }
    }
  }

  componentDidMount() {
    if (this.props.enableZoomFeature) {
      this.props.init();
    }
  }

  componentWillUnmount() {
    this.props.cleanup();
  }

  render() {
    const {
      useModernViewer,
      defaultStyle,
      shouldActivate,
      activeStyle,
      shouldEnableHover,
      hoverStyle,
      enableLiquidModeFeature
    } = this.props;

    return (
      <Fragment>
        {useModernViewer ? (
          <ButtonGroup orientation="vertical" readOnly>
            <ZoomInContainer
              className={ZoomUICss.ModernZoomIn}
              defaultStyle={defaultStyle}
              shouldActivate={shouldActivate}
              activeStyle={activeStyle}
              shouldEnableHover={shouldEnableHover}
              hoverStyle={hoverStyle}
            />
            <ZoomOutContainer
              defaultStyle={defaultStyle}
              shouldActivate={shouldActivate}
              activeStyle={activeStyle}
              shouldEnableHover={shouldEnableHover}
              hoverStyle={hoverStyle}
            />
            {enableLiquidModeFeature && (
              <LMViewSwitcherContainer
                className={ZoomUICss.ModernLiquidMode}
                defaultStyle={defaultStyle}
                shouldActivate={shouldActivate}
                activeStyle={activeStyle}
                shouldEnableHover={shouldEnableHover}
                hoverStyle={hoverStyle}
              />
            )}
          </ButtonGroup>
        ) : (
          <div className={ZoomUICss.ZoomInOut}>
            <ZoomOutContainer />
            <ZoomInContainer />
            {enableLiquidModeFeature && <LMViewSwitcherContainer className={ZoomUICss.LiquidMode} />}
          </div>
        )}
      </Fragment>
    );
  }
}

export { ZoomUI };
